import { useEffect, useState } from 'react';
import { useDebounce } from '@blaze-react/utils/lib/customHooks';
import useSearchResults from '../components/useSearchResults';
import { SEARCH_PUBLISHED } from '../constants';
const useDebounceSearch = ({
  entities,
  resultKeys,
  fields,
  initialSearchTerm
}) => {
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm !== null && initialSearchTerm !== void 0 ? initialSearchTerm : '');
  const [previousSearchTerm, setPreviousSearchTerm] = useState(null);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [{
    loading,
    results
  }, setQueryParams] = useSearchResults({
    queryKey: SEARCH_PUBLISHED,
    resultKeys,
    entities,
    fields
  });
  useEffect(() => {
    if (debouncedSearchTerm && debouncedSearchTerm !== previousSearchTerm) {
      setQueryParams({
        value: debouncedSearchTerm
      });
      setPreviousSearchTerm(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm, previousSearchTerm, setQueryParams]);
  return {
    loading,
    results,
    searchTerm,
    setSearchTerm,
    setPreviousSearchTerm,
    debouncedSearchTerm,
    previousSearchTerm
  };
};
export default useDebounceSearch;
//# sourceMappingURL=useDebounceSearch.js.map